import { useTranslation } from "react-i18next";
import "../styles/location.css";

function Location() {
  const { t } = useTranslation();

  return (
    <section id="location" className="location-section">
      <h3>{t("location.title")}</h3>
      <p>{t("location.description")}</p>
      <div className="map-container">
        <iframe
          title={t("location.mapTitle")}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1596.3787750177533!2d3.0281771!3d36.7555022!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x128fafb796ce184b%3A0x28f636ef8c5338d7!2sSARL%20BELAMRI%20INCHA%20TAAMIR!5e0!3m2!1sen!2sdz!4v1711234567890!5m2!1sen!2sdz"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
    </section>
  );
}

export default Location;
